import { Util } from '@/modules/util'
import type { ActivityFee } from '@/types/activity'
import { Request } from '@/classes/Request.ts'

export const affinetyActivities = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get('/ajax/student/' + studentAccountId + '/activity')
  const items = Util.Obj.keysToCamel(response.data.items) as ActivityFee[]

  // Convert date strings to Date objects
  return items.map(item => ({
    ...item,
    date: new Date(item.date),
    subItems: item.subItems?.map(subItem => ({
      ...subItem,
      date: new Date(subItem.date)
    }))
  }))
}
